<template>
    <div>
        <limitless-page-header
            :sub-title="(edit_user && edit_user.UserID > 0 ? edit_user.FullName : (not_found ? 'Who\'s this??' : 'Ny användare'))"
            :title-id="(edit_user && edit_user.UserID > 0 ? edit_user.UserID : '')"
        >
            <template #header-elements>
                <limitless-page-header-button @click="$router.push({ name: 'users.list' })" icon="icon-circle-left2">Tillbaka till lista</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content" style="padding-bottom: 6rem;">
            <div v-if="edit_user"></div>
            <div v-else-if="not_found">
                <i class="text-danger font-italic">Användaren hittades inte...</i>
            </div>
            <div v-else-if="error">
                <i class="text-danger font-italic">Något gick fel, kunde inte hämta data...</i>
            </div>
            <div v-else><i class="icon-spinner2 spinner"></i></div>

            <limitless-card-tabs-view :links="routes" v-show="user">
                <router-view @prductUpdated="getUser"></router-view>
                <activity-notification v-if="edit_user && edit_user.UserID > 0" :channel="'user-' + edit_user.UserID"></activity-notification>
            </limitless-card-tabs-view>
        </div>
    </div>
</template>

<script>
import LimitlessCardTabsView from '@components/Limitless/CardTabsView';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import ActivityNotification from '@components/User/ActivityNotification';
import apiClient from '@services/ApiClient';
import { hasPermission } from '@services/Helpers';
import { useAuthStore } from '@services/pinia/AuthStore';
import { mapState } from 'pinia';

export default {
    name: 'UserEditorLayout',
    components: {
        LimitlessCardTabsView,
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        ActivityNotification,
    },
    data: () => ({
        id: null,
        edit_user: null,
        error: false,
        not_found: false,
    }),
    async created() {
        this.id = this.$route.params.id;
    },
    watch: {
        '$route.params.id': function watchRouteParamsId(id) {
            this.id = id;
        },
        id: function watchId() {
            this.edit_user = null;
            this.getUser();
        },
    },
    methods: {
        hasPermission,
        getUser() {
            apiClient.get('/vue/users/' + this.id + '').then((response) => {
                this.edit_user = response.data.user;
                this.not_found = false;
                this.error = false;
            }).catch((error) => {
                this.edit_user = null;
                if (error.response) {
                    const { status } = error.response;
                    if (status === 404) {
                        this.not_found = true;
                    } else {
                        this.error = true;
                    }
                }
            });
        },
    },
    computed: {
        ...mapState(useAuthStore, ['user']),
        routes() {
            const { id } = this.$route.params;
            const arr = [];
            if (this.edit_user && this.edit_user.UserID > 0) {
                if (
                    (hasPermission('red_edit_users') && this.edit_user.UserID !== this.user.id)
                    || (hasPermission('red_edit_own_user') && this.edit_user.UserID === this.user.id)
                ) {
                    arr.push({
                        name: 'user.edit',
                        params: { id },
                        text: 'Användarinformation',
                    });
                }
                if (
                    (hasPermission('red_edit_users_information') && this.edit_user.UserID !== this.user.id)
                    || (hasPermission('red_edit_own_information') && this.edit_user.UserID === this.user.id)
                ) {
                    arr.push({
                        name: 'user.information',
                        params: { id },
                        text: 'Personuppgifter',
                    });
                }

                if (
                    (hasPermission('red_edit_users_employment') && this.edit_user.UserID !== this.user.id)
                    || (hasPermission('red_edit_own_employment') && this.edit_user.UserID === this.user.id)
                ) {
                    arr.push({
                        name: 'user.employment',
                        params: { id },
                        text: 'Anställning',
                    });
                }
                if (
                    (hasPermission('red_edit_users_permissions') && this.edit_user.UserID !== this.user.id)
                    || (hasPermission('red_edit_own_permissions') && this.edit_user.UserID === this.user.id)
                ) {
                    arr.push({
                        name: 'user.permissions',
                        params: { id },
                        text: 'Behörigheter',
                    });
                }
                if (
                    (hasPermission('red_edit_users_timecare') && this.edit_user.UserID !== this.user.id)
                    || (hasPermission('red_edit_own_user') && this.edit_user.UserID === this.user.id)
                    || (hasPermission('red_edit_own_timecare') && this.edit_user.UserID === this.user.id)
                ) {
                    arr.push({
                        name: 'user.timecare',
                        params: { id },
                        text: 'Outbetalt',
                    });
                    arr.push({
                        name: 'user.worked_hours',
                        params: { id },
                        text: 'Arbetade timmar',
                    });
                }
                if (
                    (hasPermission('red_edit_users_employment') && this.edit_user.UserID !== this.user.id)
                    || (hasPermission('red_edit_own_employment') && this.edit_user.UserID === this.user.id)
                ) {
                    arr.push({
                        name: 'user.work_schedule',
                        params: { id },
                        text: 'Arbetsschema',
                    });
                }
                if (
                    (hasPermission('red_edit_users_information') && this.edit_user.UserID !== this.user.id)
                    || (hasPermission('red_edit_own_information') && this.edit_user.UserID === this.user.id)
                ) {
                    arr.push({
                        name: 'user.image_signature',
                        params: { id },
                        text: 'Bild & Signatur',
                    });
                    arr.push({
                        name: 'user.email_signature',
                        params: { id },
                        text: 'E-postsignatur',
                    });
                }
            } else {
                arr.push({ name: 'user.edit', params: { id }, text: 'Användarinformation' });
            }
            return arr;
        },
    },
};
</script>
